import React from 'react';

const EmptyState = ({
  icon: Icon,
  title,
  description,
  children,
  containerClassName = 'card p-12 text-center',
  iconClassName = 'w-16 h-16 text-gray-300 dark:text-dark-500 mx-auto mb-4',
  titleClassName = 'text-lg font-semibold text-dark-800 dark:text-white mb-2',
  descriptionClassName = 'text-sm text-gray-500 dark:text-gray-400',
  iconBox = false,
}) => (
  <div className={containerClassName}>
    {Icon && (
      iconBox ? (
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gray-100 dark:bg-dark-700 flex items-center justify-center">
          <Icon className="w-8 h-8 text-gray-400 dark:text-gray-500" />
        </div>
      ) : (
        <Icon className={iconClassName} />
      )
    )}
    {title && <h3 className={titleClassName}>{title}</h3>}
    {description && <p className={descriptionClassName}>{description}</p>}
    {children}
  </div>
);

export default EmptyState;
